import { getFormattedCurrency } from '@/common/utils/app.utils';
import { useDashboardCountsContext } from '@/dashboard/provider/DashboardCountsProvider';

function useGetPeriodTotals(period: string) {
  const { counts } = useDashboardCountsContext();
  const periodTotals = counts[period];

  const { employeeRecords, psp, contributions, ataFees } = periodTotals.totals;

  return {
    employeeRecords: Number(employeeRecords).toLocaleString('en-US'),
    psp: getFormattedCurrency(psp),
    contributions: getFormattedCurrency(contributions),
    ataFees: getFormattedCurrency(ataFees),
  };
}

export default useGetPeriodTotals;
